import { PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { message, Space } from 'antd';

import { Button } from '../../../../components/index';
import { useChangePagination } from '../../../../hooks';
import { useGetPilotsQuery } from '../../../../services/pilotageApi';
import { useLazyExportRegistersQuery } from '../../../../services/exportApi';
import { PilotType } from '../../../../types';
import { PanelHeader } from '../panelHeader';
import { RegistersDrawer } from '../registersDrawer';
import { RegistersTable } from '../registersTable';
import { columns } from './columns';
import { PilotForm } from './PilotForm';

export function Pilot() {
  const [searchQueryTerm, setSearchQueryTerm] = useState('');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [selectedPilot, setselectedPilot] = useState<PilotType | null>(null);
  const { onChangePagination, queryPage, setQueryPage } = useChangePagination();

  const {
    data: pilotsData,
    isFetching: isFetchingPilotData,
    refetch: refetchPilotData,
  } = useGetPilotsQuery({
    name: searchQueryTerm,
    page: onChangePagination(),
    page_size: 10,
  });

  function onSavePilot() {
    setselectedPilot(null);
    refetchPilotData();
  }
  function onCloseDrawer() {
    setIsFormVisible(false);
    setselectedPilot(null);
  }

  function onSelectPilot(pilot: PilotType) {
    setselectedPilot({
      ...pilot,
    });
    setIsFormVisible(true);
  }

  const [exportRegisters, { isLoading: isExporting }] =
    useLazyExportRegistersQuery();

  async function handleExport() {
    try {
      await exportRegisters({
        exportType: 'pilots',
        params: { search: searchQueryTerm },
      }).unwrap();
      message.success(
        'Exportação em processamento. Você a receberá em seu e-mail em breve.',
        5
      );
    } catch (error) {
      message.error('Erro ao solicitar a exportação. Tente novamente.');
    }
  }

  function actionButtons() {
    return (
      <Space size={18}>
        <Button
          icon={<DownloadOutlined />}
          size="large"
          onClick={handleExport}
          loading={isExporting}
        >
          Exportar XLS
        </Button>
        <Button
          icon={<PlusOutlined />}
          type="primary"
          size="large"
          onClick={() => setIsFormVisible(true)}
        >
          Novo Prático
        </Button>
      </Space>
    );
  }
  function searchData(value: any) {
    setQueryPage(1);
    setSearchQueryTerm(value);
  }

  return (
    <>
      <RegistersDrawer visible={isFormVisible} width={640}>
        <PilotForm
          name="pilot"
          onClose={onCloseDrawer}
          selectedPilot={selectedPilot}
          onSavePilot={onSavePilot}
          setQueryPage={setQueryPage}
        />
      </RegistersDrawer>
      <PanelHeader
        panelName="pratico"
        actionButtons={actionButtons()}
        onSearch={searchData}
      />
      <RegistersTable
        rowKey="id"
        queryPage={queryPage}
        columns={columns}
        total={pilotsData?.count}
        dataSource={pilotsData?.results || []}
        onChangePagination={onChangePagination}
        isLoading={isFetchingPilotData}
        showSizeChanger={false}
        onSelectItem={onSelectPilot}
      />
    </>
  );
}
